import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from '../../../lib/axios'
import { brands } from '../../../lib/apiList'

interface EmployeeState {
    updateState: boolean
    loading: boolean
    brandList: any
    error: string
    response: string
    totalCount: number
    pageSize: number
}
interface AddBrand {
    id?: string
    name: string
    description: string
}

const employeeState: EmployeeState = {
    updateState: false,
    loading: false,
    brandList: [],
    error: '',
    response: '',
    totalCount: 0,
    pageSize: 2,
}
interface GetAllBrand {
    search: string
    currentPage: number
    recordsPerpage: number
}
export const getAllBrands = createAsyncThunk(
    'brands/getBrands',
    async ({ search, currentPage, recordsPerpage }: GetAllBrand) => {
        const data = {
            keyword: search || '',
            pageSize: recordsPerpage | 5,
            pageNumber: currentPage ? currentPage : 1,
        }
        const response = await axios.post(brands.GET_BRANDS, data)
        return response.data
    }
)
export const addBrand = createAsyncThunk(
    'brands/addBrand',
    async (data: AddBrand) => {
        const response = await axios.post(brands.ADD_BRAND, {
            name: data.name,
            description: data.description,
        })
        return response.data
    }
)
export const deleteBrand = createAsyncThunk(
    'brands/brands',
    async (id: string) => {
        const response = await axios.delete(`${brands.DELETE_BRAND}/${id}`)
        return response.data
    }
)
export const editBrand = createAsyncThunk(
    'brands/editBrand',
    async (data: AddBrand) => {
        const response = await axios.put(`${brands.EDIT_BRAND}/${data.id}`, {
            id: data.id,
            name: data.name,
            description: data.description,
        })
        return response.data
    }
)
const brandSlice = createSlice({
    name: 'employee',
    initialState: employeeState,
    reducers: {
        changeStateTrue: (state) => {
            state.updateState = true
        },
        changeStateFalse: (state) => {
            state.updateState = false
        },
        clearResponse: (state) => {
            state.response = ''
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAllBrands.fulfilled, (state, action) => {
            state.brandList = action.payload.data
            state.totalCount = action.payload.totalCount
            state.pageSize = action.payload.pageSize
        })
        builder.addCase(getAllBrands.rejected, (state, action) => {
            state.error = action.error.message || ''
        })
        builder.addCase(deleteBrand.fulfilled, (state, action) => {
            state.response = 'Brand deleted successfully'
            state.brandList = state.brandList.filter(
                (brand: AddBrand) => brand.id !== action.meta.arg
            )
        })
        builder.addCase(addBrand.fulfilled, (state, action) => {
            state.response = 'Brand added successfully'
            const data = action.meta.arg
            const newBrand = {
                id: action.payload,
                name: data.name,
                description: data.description,
            }
            // add new brand top of the list
            state.brandList.unshift(newBrand)
        })
        builder.addCase(editBrand.fulfilled, (state, action) => {
            state.response = 'Brand updated successfully'
            const data = action.meta.arg
            const index = state.brandList.findIndex(
                (brand: any) => brand.id === data.id
            )
            state.brandList[index] = {
                id: data.id,
                name: data.name,
                description: data.description,
            }
        })
    },
})

export default brandSlice.reducer

export const { changeStateTrue, changeStateFalse, clearResponse } =
    brandSlice.actions
